import ScrollMagic from 'scrollmagic'
import * as Util from '../util/utilities'

export default {
    init() {
        const scrollcontrol = new ScrollMagic.Controller()
        const windowHalfX = window.innerHeight / 2

        this.fadeIn(scrollcontrol, windowHalfX)
        this.fadeInUp(scrollcontrol, windowHalfX)
        this.fadeInRight(scrollcontrol, windowHalfX)
        this.fadeInLeft(scrollcontrol, windowHalfX)
        this.revealRight(scrollcontrol, windowHalfX)
        this.revealBlock(scrollcontrol, windowHalfX)
    },
    /* :: Fade-In
    {+} ---------------------------------- */
    fadeIn(scrollcontrol, windowHalfX) {
        if ($('[data-fadein]').length) {
            $('[data-fadein]').each(function () {
                let delay
                let data = this.getAttribute('data-fadein')
                const yoyo = $(this).data('ani-yoyo')
                let repeat = yoyo == undefined ? false : true

                if (data) {
                    delay = data
                } else {
                    delay = 0.1
                }

                Util.addAnimations(
                    [
                        TweenMax.fromTo(
                            $(this),
                            0.8,
                            {
                                opacity: 0,
                            },
                            {
                                opacity: 1,
                                delay: delay,
                                ease: Power3.easeOut,
                            },
                        ),
                    ],
                    this,
                    '',
                    -windowHalfX + 100,
                    '',
                    scrollcontrol,
                    repeat,
                )
            })
        }
    },

    /* :: Fade-In Up
    {+} ---------------------------------- */
    fadeInUp(scrollcontrol, windowHalfX) {
        if ($('[data-fadein-up]').length) {
            $('[data-fadein-up]').each(function () {
                let delay
                let data = this.getAttribute('data-fadein-up')
                const yoyo = $(this).data('ani-yoyo')
                let repeat = yoyo == undefined ? false : true

                if (data) {
                    delay = data
                } else {
                    delay = 0.1
                }

                Util.addAnimations(
                    [
                        TweenMax.fromTo(
                            $(this),
                            0.8,
                            {
                                opacity: 0,
                                y: '32',
                            },
                            {
                                opacity: 1,
                                y: '0',
                                delay: delay,
                                ease: Power3.easeOut,
                            },
                        ),
                    ],
                    this,
                    '',
                    -windowHalfX + 100,
                    '',
                    scrollcontrol,
                    repeat,
                )
            })
        }
    },

    /* :: Fade-In Right
    {+} ---------------------------------- */
    fadeInRight(scrollcontrol, windowHalfX) {
        if ($('[data-fadein-right]').length) {
            $('[data-fadein-right]').each(function () {
                let delay
                let data = this.getAttribute('data-fadein-right')
                const yoyo = $(this).data('ani-yoyo')
                let repeat = yoyo == undefined ? false : true

                if (data) {
                    delay = data
                } else {
                    delay = 0.1
                }

                Util.addAnimations(
                    [
                        TweenMax.fromTo(
                            $(this),
                            0.8,
                            {
                                opacity: 0,
                                x: '-32',
                            },
                            {
                                opacity: 1,
                                x: '0',
                                delay: delay,
                                ease: Power3.easeOut,
                            },
                        ),
                    ],
                    this,
                    '',
                    -windowHalfX + 100,
                    '',
                    scrollcontrol,
                    repeat,
                )
            })
        }
    },

    /* :: Fade-In Left
    {+} ---------------------------------- */
    fadeInLeft(scrollcontrol, windowHalfX) {
        if ($('[data-fadein-left]').length) {
            $('[data-fadein-left]').each(function () {
                let delay
                let data = this.getAttribute('data-fadein-left')
                const yoyo = $(this).data('ani-yoyo')
                let repeat = yoyo == undefined ? false : true

                if (data) {
                    delay = data
                } else {
                    delay = 0.32
                }

                Util.addAnimations(
                    [
                        TweenMax.fromTo(
                            $(this),
                            0.8,
                            {
                                opacity: 0,
                                x: '32',
                            },
                            {
                                opacity: 1,
                                x: '0',
                                delay: delay,
                                ease: Power3.easeOut,
                            },
                        ),
                    ],
                    this,
                    '',
                    -windowHalfX + 100,
                    '',
                    scrollcontrol,
                    repeat,
                )
            })
        }
    },

    /* :: Reveal Right
    {+} ---------------------------------- */
    revealRight(scrollcontrol, windowHalfX) {
        if ($('[data-reveal-right]')) {
            $('[data-reveal-right]').each(function () {
                const content = $(this).find('[data-reveal-content]')
                const cover01 = $(this).find('[data-reveal-cover01]')
                const cover02 = $(this).find('[data-reveal-cover02]')
                const data = this.getAttribute('data-reveal-right')
                const swipe = new TimelineMax()
                let delay

                if (data) {
                    delay = data
                } else {
                    delay = 0.32
                }

                Util.addAnimations(
                    [
                        swipe
                            .to(cover02, 0.4, { x: '0%', delay: delay, ease: Circ.easeInOut })
                            .set(cover01, { opacity: 0 })
                            .to(cover02, 0.4, { x: '101%', ease: Circ.easeInOut }),
                    ],
                    this,
                    '',
                    -windowHalfX + 100,
                    '',
                    scrollcontrol,
                    false,
                )
            })
        }
    },

    /* :: Block Reveal
    {+} ---------------------------------- */
    revealBlock(scrollcontrol, windowHalfX) {
        if ($('[data-block-revealer]').length) {
            $('[data-block-revealer]').each(function () {
                const content = $(this).find('[data-revealer-content]')
                const element = $(this).find('[data-revealer-element]')
                const data = this.getAttribute('data-block-revealer')
                const swipe = new TimelineMax()
                let delay

                if (data) {
                    delay = data
                } else {
                    delay = 0.32
                }

                Util.addAnimations(
                    [
                        swipe
                            .to(element, 0.4, { x: '0%', delay: delay, ease: Circ.easeInOut })
                            .to(content, 0, { opacity: 1 })
                            .to(element, 0.4, { x: '101%', ease: Circ.easeInOut }),
                    ],
                    this,
                    '',
                    -windowHalfX + 100,
                    '',
                    scrollcontrol,
                    false,
                )
            })
        }
    },
}
